/**
 * The layout vocabulary stored descriptors are written in: a value per measured width, and the named
 * spacing steps.
 *
 * Here rather than in the site UI because a Form descriptor is stored by phis-server and states its
 * gaps and ranges in these terms, so the server has to read them the way the renderer does.
 */
/** A stated value cascades upwards to the wider modes; the fallback answers only where nothing is. */
export function resolvePhiResponsiveValue(value, fallback) {
    if (!value)
        return fallback;
    const compact = value.compact ?? fallback.compact;
    const medium = value.medium ?? (value.compact === undefined ? fallback.medium : compact);
    const wide = value.wide ?? (value.medium === undefined && value.compact === undefined ? fallback.wide : medium);
    return { compact, medium, wide };
}
export const PHI_SPACING_TOKENS = [
    "none",
    "xxs",
    "xs",
    "sm",
    "base",
    "md",
    "lg",
    "xl",
    "xxl",
];
export function isPhiSpacingToken(value) {
    return typeof value === "string" && PHI_SPACING_TOKENS.includes(value);
}
